import { useContext } from 'react';
import { SignatureContext } from '../../context/SignatureContext';
import { TYPES } from '../../../../config/constants/typesReducers';
import { useState } from 'react';
import { useEffect } from 'react';
import { FormMobile } from './platform/FormMobile';
import { FormDesktop } from './platform/FormDesktop';
import { useMemo } from 'react';

export const SignatureForm = () => {
  const [ isMobile, setIsMobile ] = useState(false);

  const { signatureState, signatureDispatch, fieldRef } = useContext(SignatureContext);
  const { config: { sortedFields } } = signatureState; 

  const sortedFieldsArray = useMemo(() => {
    if (!sortedFields || typeof sortedFields !== 'object') return [];
    return Object.values(sortedFields);
  }, [sortedFields]);

  const [ currentField, setCurrentField ] = useState(sortedFieldsArray[0] || null);
  const [ indexSortedField, setIndex ] = useState(0);
  const [ valueField, setValueField ] = useState('');

  const lengthSortedFields = useMemo(() => sortedFieldsArray.length, [sortedFieldsArray]);

  const handleBeforeField = () => {
    if (indexSortedField === 0) return;

    setIndex((oldValue) => {
      const newValue = oldValue - 1;
      setCurrentField(sortedFieldsArray[newValue]);

      return newValue;
    })
  };

  const handleNextField = () => {
    if(!isMobile){
      event.preventDefault();
      const action = {
        type: TYPES.SIGNATURE.EDIT_FIELDS,
        payload: {
          field: currentField,
          value: valueField,
        }
      }

      signatureDispatch(action);
    };
    if (indexSortedField === lengthSortedFields - 1) return;

    setIndex((oldValue) => {
      const newValue = oldValue + 1;
      setCurrentField(sortedFieldsArray[newValue]);

      return newValue;
    });
  };

  useEffect(()=>{
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    }

    // Ejecutar inmediatamente para establecer el estado inicial
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    }
  },[]);

  // Actualiza el campo seleccionado dependiendo los botones de navegación
  useEffect(()=>{
    const currentField = sortedFieldsArray[indexSortedField];
    if (currentField) {
      setCurrentField(currentField);
    }
  },[indexSortedField, sortedFieldsArray]);

  // Enfoca el campo actual dependiendo el botón de navegación
  useEffect(() => {
    const fieldData = sortedFieldsArray[indexSortedField];
    if (!fieldData || !fieldData.field) return;

    const {field} = fieldData; 

    const action = {
      type: TYPES.SIGNATURE.FOCUS_FIELD,
      payload:field,
    }

    signatureDispatch(action);

    if(!fieldRef)return
    fieldRef.current.scrollIntoView({behavior:'smooth', block:"center"})

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signatureDispatch, fieldRef, indexSortedField]);

  // Sincroniza valueField del sidebar cuando el contexto cambia
  // (p.ej. cuando el usuario firma directamente desde el campo en el documento)
  const currentFieldCtxValue = signatureState?.signature?.fieldsByPage?.[currentField?.field?.page]?.[currentField?.field?.id]?.value ?? '';
  useEffect(() => {
    setValueField(currentFieldCtxValue);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFieldCtxValue]);

  // Mostrar un mensaje de carga si no hay campos disponibles
  if (!sortedFieldsArray || sortedFieldsArray.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '200px',
        fontSize: '18px',
        color: '#666'
      }}>
        Cargando campos de firma...
      </div>
    );
  }

  return (
    <> 
      {
        isMobile 
        ? <FormMobile 
            handleBeforeField={handleBeforeField}
            handleNextField={handleNextField}
            currentField={currentField}
            sortedFields={sortedFields}
            indexSortedField={indexSortedField}
          /> 
        : <FormDesktop
            currentField={currentField}
            sortedFields={sortedFields}
            indexSortedField={indexSortedField}
            valueField={valueField}
            setValueField={setValueField}
            handleBeforeField={handleBeforeField}
            handleNextField={handleNextField}
          />
      }
    </>
  )
}